import _ from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import { useMarketCore } from "../../../../cores/market";
import {
  MercadolibreOrderByOptions,
  MercadolibreOrderOptions,
  MercadolibreOrderStatus,
  MercadolibreStatusOptions,
} from "../../../../cores/market/mercadolibre.config";
import { useMeCore } from "../../../../cores/me";
import { InputWembii } from "../../InputWembii";
import { PaginationWemmbii } from "../../pagination/Pagination";
import { PanelWembii } from "../../PanelWembii";
import { useIntl } from "react-intl";

export const MercadolibreOrderBar = () => {
  const intl = useIntl();
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("date");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState<MercadolibreOrderStatus | string>("");
  const { getMercadolibreOrders, mercadolibreOrders: orders } = useMarketCore();
  const { company, socialSettings } = useMeCore();

  const isSync = useMemo(() => socialSettings && socialSettings.mercadoLibre, [
    socialSettings,
  ]);

  const debouncedSearch = useRef(
    _.debounce(
      (search) =>
        getMercadolibreOrders(company!.id, {
          search,
          order,
          orderBy,
          perPage,
          page,
          status,
        }),
      1000
    )
  ).current;

  useEffect(() => {
    setPage(1);
    setPerPage(10);
    isSync && debouncedSearch(search);
  }, [debouncedSearch, search, isSync]);

  useEffect(() => {
    setPage(1);
    setPerPage(10);
    isSync &&
      getMercadolibreOrders(company!.id, {
        order,
        orderBy,
        status,
      });
  }, [company, getMercadolibreOrders, order, orderBy, status, isSync]);

  useEffect(() => {
    isSync &&
      getMercadolibreOrders(company!.id, {
        order,
        orderBy,
        status,
        perPage,
        page,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, getMercadolibreOrders, perPage, page, isSync]);

  return (
    <PanelWembii className="w-100 px-4 py-3 mb-3 pointer" shadow>
      <Row>
        <Col xs="12" lg="3">
          <InputWembii
            label={intl.formatMessage({ id: "app.onlineSales.search" })} 
            placeholder={intl.formatMessage({ id: "app.onlineSales.search1" })} 
            type="text"
            onChange={(value) => setSearch(value)}
            value={search}
          />
        </Col>
        <Col xs="6" lg="2">
          <InputWembii
            label={intl.formatMessage({ id: "app.onlineSales.order" })} 
            type="select"
            onChange={(value) => setOrder(value)}
            value={order}
          >
            {MercadolibreOrderOptions.map(({ value, label }) => (
              <option key={label} value={value}>
                {label}
              </option>
            ))}
          </InputWembii>
        </Col>
        <Col xs="6" lg="2">
          <InputWembii
            label={intl.formatMessage({ id: "app.onlineSales.orderBy" })} 
            type="select"
            onChange={(value) => setOrderBy(value)}
            value={orderBy}
          >
            {MercadolibreOrderByOptions.map(({ value, label }) => (
              <option key={label} value={value}>
                {label}
              </option>
            ))}
          </InputWembii>
        </Col>
        <Col xs="12" lg="3"> 
          <InputWembii
            label={intl.formatMessage({ id: "app.onlineSales.state" })} 
            type="select"
            onChange={(value) => setStatus(value)}
            value={status}
          >
            {MercadolibreStatusOptions.map(({ value, label }) => (
              <option key={label} value={value}>
                {label}
              </option>
            ))}
          </InputWembii>
        </Col>
        <Col xs="12" lg="auto">
          <PaginationWemmbii
            className="w-fit mx-auto mr-lg-0 ml-lg-auto"
            page={page}
            setPage={setPage}
            perPage={perPage}
            setPerPage={setPerPage}
            disabledPages={orders.length < perPage}
          />
        </Col>
      </Row>
    </PanelWembii>
  );
};
